export default {
  sub_kategori_sos: [],
  kategori_sos: []
}